import { locationTypeEntityName, missionLocationEntityName, missionPositionEntityName, missionTypeEntityName, } from '../../../../backend/config/classifiers';
import { requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { buildValueProvider } from '@juvare/platform-sdk-react/ui/features/classifiers';
export function buildMissionsClassifierValueProviders(appName, userState) {
    return [
        buildValueProvider(appName, locationTypeEntityName, 'Location Type', false, locationTypeEntityName, (client) => {
            return client
                .storageList({
                filter: [{ column: 'status', op: '=', value: 'active' }],
            })
                .then((result) => result.rows.map((row) => ({ value: row.id, label: row.columns.name })));
        }),
        buildValueProvider(appName, missionLocationEntityName, 'Mission Location', false, missionLocationEntityName, (client) => {
            return client
                .storageList({ filter: [{ column: 'status', op: '=', value: 'active' }], orderBy: [{ column: 'name' }] })
                .then((result) => {
                return result.rows.map((row) => ({
                    label: row.columns.name,
                    value: row.id,
                    description: row.columns.fullAddress,
                }));
            });
        }),
        buildValueProvider(appName, missionTypeEntityName, 'Mission Type', false, missionTypeEntityName, (client) => {
            var _a;
            const authorizedMissionTypeIds = (_a = userState === null || userState === void 0 ? void 0 : userState.authorizedMissionTypeIds) !== null && _a !== void 0 ? _a : [];
            return client
                .storageList({
                filter: [{ column: 'status', op: '=', value: 'active' }],
                orderBy: [{ column: 'name' }],
            })
                .then((result) => {
                return result.rows.reduce((missionTypeValues, missionType) => {
                    if (requireAnySystemPermission(userState, 'manage-missions') || authorizedMissionTypeIds.includes(missionType.id)) {
                        missionTypeValues.push({
                            label: missionType.columns.name,
                            value: missionType.id,
                        });
                    }
                    return missionTypeValues;
                }, []);
            });
        }),
        buildValueProvider(appName, missionPositionEntityName, 'Mission Position', false),
    ];
}
